<script>
  import ArrowIcon from "./ArrowIcon.svelte";
  import "Static/coin.css";
  import { scale } from "svelte/transition";
  import { elasticOut, cubicOut } from "svelte/easing";

  import { useMachine } from "@xstate/svelte";

  import { coinMachine } from "./CoinWidgetSm";

  import { createEventDispatcher } from "svelte";

  import { coinPosition } from "Store/CoinPositionStore";

  import {useMarkers} from 'Utils/useMarkers.js';

  import {
    settingsStore,
    coinsInfoStore,
    extWinStore,
    campaingStore,
  } from "Store/data.js";
  import { scaleFade } from "Utils/transition";
  import { onMount } from "svelte";
  import bIcon from "Static/B.png";
  import arrowIcon from "Static/arrows.png";

  import CoinText from "./CoinText.svelte";

  import { _ } from "Utils/i18";
  import { sendTrack, TrackEvent } from "Utils/AmplitudeHelper";

  //import { isLeftHandedUI } from "Utils/settings";

  const dispatch = createEventDispatcher();

  const { anyMarker, deactivateMarker } = useMarkers();
  const marker = anyMarker;
  
  let coinWidget;

  const COIN_VIEWS = {
    DEFAULT: "default",
    MAX_POSSIBLE_WIN: "max_possible_win",
    HITS_LEFT: "hits_left",
    EXTERNAL_WIN: "external_win",
  };

  const TIP_FADE_IN_TIME = 1000;
  const TIP_FADE_OUT_TIME = 500;
  let currentCoinView = COIN_VIEWS.DEFAULT;
  let coinFrame = 0;

  $: coinData = coinsInfoStore.coinValueInfo;
  



  let widgetStyle = "widget";
  let winLintSytle = "winline";

  $: if (xPos < 0) {
    winLintSytle = "winline";
  } else {
    winLintSytle = "winline winline-left-handed";
  }

  


  $: settings = settingsStore.settings;
  $: {
    if ($settings.isCoinClicked) {
      send({ type: "IS_COIN_CLICKED" });
    } 
  }

  $: {
    if ($settings.isCoinEnabled) {
		widgetStyle = "widget"
    } else {
		widgetStyle = "widget coin-disabled"
	}
  }


  $: winToShow = extWinStore.externalWinToShow;

  const ORIENTATION = {
    PORTRAIT: "portrait",
    LANDSCAPE: "landscape",
  };

  let deltaX = 0;
  let deltaY = 0;

  let xPos = 0;
  let yPos = 0;

  $: currentOrientation = $settings.orientation;

  //$: userSubscription = campaingStore.userSubscription;

  

  // $: {
  //   if ($userSubscription.subscribed) {
  //     send({ type: "SUBSCRIBED" });
  //   } else {
  //     send({ type: "UNSUBSCRIBED" });
  //   }
  // }


  // $: casino = campaingStore.casino;

  // $: {
  //   if ($casino.category === "commercial")
  //   {
  //     send({ type: "COMMERCIAL" });
  //   } else {
  //     send({ type: "SOCIAL" });
  //   }
  // }




  const coinContext = {
    subscribeMsgInterval: 0,
    showSubscribeMsg:false,
    frame: 0,
    tick: 0,
    interval: 0.05,
    frameCounts: 9,
    isExternalWin: false,
    coinStateCount: 3,
    nextState: 0,
    isSubscribed: true,
    userUnSubscribe: null,
    casinoCategory:"commercial",
    isCoinClicked:false,
    px: 0,
    py: 0,
    dx: 0,
    dy: 0,
  };

  let gameScale = 1;
  let w = 1920;
  let h = 1080;

  $: {
    gameScale = $settings.gameScale;
    currentOrientation = $settings.orientation;
    w = $settings.w;
    h = $settings.h;
  }

  let PORTRAIT_PADDING_X = 45 * gameScale;
  let PORTRAIT_PADDING_Y = 45 * gameScale;

  let LANDSCAPE_PADDING_X = 50 * gameScale;
  let LANDSCAPE_PADDING_Y = 100 * gameScale;

  // $: {
  //   controllDragBoudary(deltaX, deltaY);
  // }

  function controllDragBoudary() {
    if (currentOrientation == ORIENTATION.PORTRAIT) {
      if (deltaX < (PORTRAIT_PADDING_X - $settings.w / 2) / gameScale) {
        deltaX = (PORTRAIT_PADDING_X - $settings.w / 2) / gameScale;
      }

      if (deltaX > (-PORTRAIT_PADDING_X + $settings.w / 2) / gameScale) {
        deltaX = (-PORTRAIT_PADDING_X + $settings.w / 2) / gameScale;
      }

      if (deltaY < (PORTRAIT_PADDING_Y - $settings.h / 2) / gameScale) {
        deltaY = (PORTRAIT_PADDING_Y - $settings.h / 2) / gameScale;
      }

      if (deltaY > (-PORTRAIT_PADDING_Y + $settings.h / 2) / gameScale) {
        deltaY = (-PORTRAIT_PADDING_Y + $settings.h / 2) / gameScale;
      }
    } else {
      if (deltaX < (LANDSCAPE_PADDING_X - $settings.w / 2) / gameScale) {
        deltaX = (LANDSCAPE_PADDING_X - $settings.w / 2) / gameScale;
      }
      if (deltaX > (-LANDSCAPE_PADDING_X + $settings.w / 2) / gameScale) {
        deltaX = (-LANDSCAPE_PADDING_X + $settings.w / 2) / gameScale;
      }
      if (deltaY < (LANDSCAPE_PADDING_Y - $settings.h / 2) / gameScale) {
        deltaY = (LANDSCAPE_PADDING_Y - $settings.h / 2) / gameScale;
      }
      if (deltaY > (-LANDSCAPE_PADDING_Y + $settings.h / 2) / gameScale) {
        deltaY = (-LANDSCAPE_PADDING_Y + $settings.h / 2) / gameScale;
      }
    }
    // console.log(
    //   `ORIENTATION | " + ${currentOrientation} deltaX:${deltaX} deltaY:${deltaY}| `
    // );
    coinPosition.save(deltaX, deltaY);

    xPos = deltaX;
    yPos = deltaY;
  }

  document.addEventListener("fullscreenchange", () => {
    console.log("fullscreenchange | ");
    onWindowResize();
  });

  window.addEventListener("resize", onWindowResize);

  function onWindowResize() {
    try {
    let s = 0.5;
    PORTRAIT_PADDING_X =
      s * coinWidget.getBoundingClientRect().width + 40 * gameScale;
    PORTRAIT_PADDING_Y =
      s * coinWidget.getBoundingClientRect().height +
      Math.max(50 * gameScale, 20);

    LANDSCAPE_PADDING_X = (s + 0.0) * coinWidget.getBoundingClientRect().width;
    LANDSCAPE_PADDING_Y =
      (s + 0.1) * coinWidget.getBoundingClientRect().height + 120 * gameScale;
    //120 / gameScale;
    //(s + 0.1) * coinWidget.getBoundingClientRect().height;

    if (currentOrientation === ORIENTATION.PORTRAIT) {
      deltaX = (PORTRAIT_PADDING_X - $settings.w / 2) / gameScale;
      deltaY = (PORTRAIT_PADDING_Y - $settings.h / 2) / gameScale;
    } else {
      deltaX = (LANDSCAPE_PADDING_X - $settings.w / 2) / gameScale;
      deltaY = (-LANDSCAPE_PADDING_Y + $settings.h / 2) / gameScale;
    }

    

    xPos = deltaX;
    yPos = deltaY;
    coinPosition.clear();
  }catch(e){
    console.error(e)
  }


  }

  onMount(() => {
    if (coinPosition.isSaved()) {
      //console.info("ON MOUNt...................... is Saved: ");
      let localPos = coinPosition.getPos();
      deltaX = localPos.deltaX;
      deltaY = localPos.deltaY;

      xPos = deltaX;
      yPos = deltaY;
    } else {
      onWindowResize();
    }

    return () => {
      window.removeEventListener("resize", onWindowResize);
      document.removeEventListener("fullscreenchange", onWindowResize);
      deactivateMarker()
    };
  });

  const { state, send } = useMachine(coinMachine.withContext(coinContext), {
    actions: {
      beforeDragging: (context, event) => {
        context.startClickX = event.pos.x;
        context.startClickY = event.pos.y;
      },

      openMenu: () => {
        dispatch("openMenu", "hi");
        settings.update(o => {
        o.isCoinClicked = true;
        return o;
    });


      },
      checkExternalWin: (context) => {
        extWinStore.checkExternalWin();
        if ($winToShow) {
          context.isExternalWin = true;
        } else {
          context.isExternalWin = false;
        }
      },
      removeExternalWin: (context) => {
        if (context.isExternalWin) {
          setTimeout(() => {
            extWinStore.removeExternalWin();
          }, 0);
        }
      },

      startDragging: (context, event) => {
        let distance = Math.hypot(
          context.startClickX - event.pos.x,
          context.startClickY - event.pos.y
        );

        //console.log(`startDragging distance: ${distance}`);
        if (distance < 1) return;

        function sendTouchPosition(event) {
          event.stopPropagation();

          const touch = event.touches[0];
          send({
            type: "window_mousemove",
            pos: {
              x: touch.clientX,
              y: touch.clientY,
              dx: event.movementX,
              dy: event.movementY,
            },
          });
        }

        function sendPosition(event) {
          event.preventDefault();
          send({
            type: "window_mousemove",
            pos: {
              x: event.clientX,
              y: event.clientY,
              // x: event.pageX,
              // y: event.pageY,
              dx: event.movementX,
              dy: event.movementY,
            },
          });
        }

        if (context.coinStateCount > 2) {
          sendTrack(TrackEvent.CoinMoved);
        }

        context.offSetX = event.pos.x;
        context.offSetY = event.pos.y;

        dispatch("startDragging");
        window.postMessage({ name: "pause_gameplay" });
        //TODO: send event star dragging to Popup

        window.addEventListener("mousemove", sendPosition);
        window.addEventListener("touchmove", sendTouchPosition);

        window.addEventListener(
          "mouseup",
          (event) => {
            event.preventDefault();
            window.removeEventListener("mousemove", sendPosition);

            send({
              type: "window_mouseup",
            });
            //
          },
          { once: true }
        );

        window.addEventListener(
          "mouseleave",
          (event) => {
            event.preventDefault();
            window.removeEventListener("mousemove", sendPosition);

            send({
              type: "window_mouseup",
            });
            //
          },
          { once: true }
        );

        window.addEventListener(
          "touchcancel",
          (event) => {
            event.preventDefault();
            window.removeEventListener("touchmove", sendTouchPosition);

            send({
              type: "window_mouseup",
            });
            //
          },
          { once: true }
        );

        window.addEventListener(
          "touchend",
          (event) => {
            event.preventDefault();
            window.removeEventListener("touchmove", sendTouchPosition);

            send({
              type: "window_mouseup",
            });
            //
          },
          { once: true }
        );
        //gestureend
        window.addEventListener(
          "gestureend",
          (event) => {
            event.preventDefault();
            window.removeEventListener("touchmove", sendTouchPosition);

            send({
              type: "window_mouseup",
            });
            //
          },
          { once: true }
        );
      },

      stopDragging: (context) => {
        window.postMessage({ name: "resume_gameplay" }, "*");
        console.log("CoinWidget: stopDragging");
        dispatch("stopDragging");

        controllDragBoudary();
      },

      updateWidgetPosition: (context, event) => {
        let scale = $settings.gameScale;

        deltaX += (event.pos.x - context.offSetX) / scale;
        deltaY += (event.pos.y - context.offSetY) / scale;

        context.offSetX = event.pos.x;
        context.offSetY = event.pos.y;
        controllDragBoudary(deltaX, deltaY);
      },
    },
  });

  function onMouseMove(event) {
    send({
      type: "mousemove",
      pos: {
        x: event.clientX,
        y: event.clientY,
        // x: event.pageX,
        // y: event.pageY,
        dx: event.movementX,
        dy: event.movementY,
      },
    });
  }

  function onTouch(event) {
    event.preventDefault();
    const touch = event.touches[0];
    send({
      type: "mousemove",
      pos: {
        x: touch.clientX,
        y: touch.clientY,
        // x: event.pageX,
        // y: event.pageY,
      },
    });
  }

  function onTouchStart(event) {
    event.preventDefault();

    const touch = event.touches[0];

    send({
      type: "mousedown",
      pos: {
        x: touch.clientX,
        y: touch.clientY,
        // x: event.pageX,
        // y: event.pageY,
      },
    });
  }

  function onMouseDown(event) {
    event.preventDefault();
    send({
      type: "mousedown",
      pos: {
        x: event.clientX,
        y: event.clientY,
        // x: event.pageX,
        // y: event.pageY,
        dx: event.movementX,
        dy: event.movementY,
      },
    });
  }

  function onMouseOver(event) {
    send({ type: "mouseover" });
  }

  function onMouseOut(event) {
    send({ type: "mouseout" });
  }

  function onMouseUp(event) {
    send({ type: "mouseup" });
  }

  function onSubscribeClick() {
    //send({ type: "mouseup" });
    dispatch("openMenu", "hi");
    settings.update(o => {
        o.isCoinClicked = true;
        return o;
    });


  }
</script>

<!-- {#if coinData} -->
  <!-- svelte-ignore missing-declaration -->
  <!-- svelte-ignore a11y-mouse-events-have-key-events -->
  <div
    bind:this={coinWidget}
    class={widgetStyle}
    style="--xpos:{xPos}px; --ypos:{yPos}px;"
    on:mousedown={onMouseDown}
    on:mousemove={onMouseMove}
    on:mouseup={onMouseUp}
    on:mouseover|stopPropagation={onMouseOver}
    on:touchstart={(event) => {
      onTouchStart(event);
    }}
    on:touchend={() => send("mouseup")}
    on:touchmove={onTouch}
    on:click|stopPropagation
  >
  {#if $marker.isValid}
  <div class="marker"></div>
  {/if}

    {#if $state.matches("Normal.ExternalWin") && $winToShow !== null}
      <div
        class={winLintSytle}
        transition:scaleFade={{ easing: cubicOut, duration: 500, x: true }}
      >
        <!-- <span class="winline-player">{$winToShow.playerNickname}</span> -->
        <span class="winline-player">Ivan Tomson</span>

        {$_("widget.winline")}
      </div>
    {/if}

    {#if $state.matches("Normal.SubscriptionPopup")}
      <div
        class={winLintSytle}
        transition:scaleFade={{ easing: cubicOut, duration: 500, x: true }}
        on:mousedown|preventDefault|stopPropagation={onSubscribeClick}
        style:cursor= "pointer"
      >
        <span class="winline-player"
          >{@html $_("widget.subscription_popup_tip")}
        </span>

        <ArrowIcon class="winline-arrow" />
      </div>
    {/if}

    <div
      class="coin coin-sprite coin-{$state.context.frame}"
      style:cursor={$state.matches("Normal.Dragging") ? "grab" : "pointer"}
    >
      {#if $state.matches("Normal.ExternalWin") || $state.matches("Normal.SubscriptionPopup") }
        <span
          class="coin-tip"
          in:scale={{ easing: elasticOut, duration: TIP_FADE_IN_TIME }}
          out:scale={{ easing: cubicOut, duration: TIP_FADE_OUT_TIME }}
        >
          <img
            class="coin-tip-b"
            src={bIcon}
            alt="B letter"
            draggable="false"
          />
        </span>
      {/if}
      {#if $state.matches("Normal.ShowHits")}
      <span
      class="coin-tip"
      in:scale={{ easing: elasticOut, duration: TIP_FADE_IN_TIME }}
      out:scale={{ easing: cubicOut, duration: TIP_FADE_OUT_TIME }}
    >
      <img
        class="coin-tip-b"
        src={bIcon}
        alt="B letter"
        draggable="false"
      />
    </span>

      {/if}
      {#if $state.matches("Normal.ShowMaxWin")}
      
      <span
      class="coin-tip"
      in:scale={{ easing: elasticOut, duration: TIP_FADE_IN_TIME }}
      out:scale={{ easing: cubicOut, duration: TIP_FADE_OUT_TIME }}
    >
      <img
        class="coin-tip-b"
        src={bIcon}
        alt="B letter"
        draggable="false"
      />
    </span>
      {/if}

      {#if $state.matches("Drag.MouseDown") || $state.matches("Drag.Dragging") || $state.matches("Drag.MouseOver")}
        <span class="coin-tip">
          <img
            class="coin-tip-b"
            draggable="false"
            src={bIcon}
            alt="B letter"
          />
        </span>
      {/if}
      {#if $state.matches("Normal.DragAndDropHint")}
        <span
          class="coin-tip"
          in:scale={{ easing: elasticOut, duration: TIP_FADE_IN_TIME }}
          out:scale={{ easing: cubicOut, duration: TIP_FADE_OUT_TIME }}
        >
          <img
            class="arrow-tip-arrow"
            draggable="false"
            src={arrowIcon}
            alt="Cross Arrows"
          />
        </span>
      {/if}
    </div>
  </div>
  <!-- </div> -->
<!-- {/if} -->

<style>


  .widget {
    position: fixed;
    /* position: absolute; */
    z-index: 3;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    transform: scale(0.85) scale(var(--game-scale)) translate(-50%, -50%)
      translateZ(0);

    transform-origin: top left;

    left: calc(50% + var(--xpos) * var(--game-scale));
    top: calc(50% + var(--ypos) * var(--game-scale));
  }

  .widget.coin-disabled {
	pointer-events: none;
	filter: brightness(0.5);
  }
  
  @media (orientation: landscape) {
    /* .widget {
      
    } */

    .widget-left-handed {
      transform-origin: left bottom;
      left: calc(50% + 777px * var(--game-scale));

      top: auto;
      bottom: calc((120px * var(--game-scale)));
    }
  }
  /* @media (orientation: portrait) {
    .widget {
      transform-origin: left top;
      left: calc(40px * var(--game-scale));
      top: max(calc(50px * var(--game-scale)), 20px);
      bottom: auto;
    }
  } */

  /* (Optional) Apply a "closed-hand" cursor during drag operation. */

  .coin {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    overflow: unset;
  }
  .coin-tip {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 120px;
    pointer-events: none;
    touch-action: none;
  }
  .coin-tip-b {
    height: 0.8em;
    margin-left: 0.08em;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: inherit;
    pointer-events: none;
    touch-action: none;
  }
  .coin-tip-arrow {
    height: 0.8em;
    --margin-left: 0.08em;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: inherit;
    pointer-events: none;
    touch-action: none;
  }

  .winline {
    position: absolute;
    display: flex;
    --flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: -1;
    top: 5px;
    bottom: 5px;
    left: 50%;
    width: 730px;
    padding-left: 0.8em;
    gap: 0.8em;
    transform-origin: left;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;

    font-size: 60px;
    font-family: "IBM Plex Sans";
    font-weight: 700;
    line-height: 1;
    color: white;
    white-space: nowrap;

    background: #ffa000;
    background: linear-gradient(
      to right,
      #ff4a2f 0%,
      #ff6b03 50%,
      #ffa000 100%
    );
  }

  .winline-left-handed {
    justify-content: flex-end;
    padding-left: 1em;
    
    gap: 0.5em;
    left: -650px;
    transform-origin: right;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;

    flex-flow: row-reverse;
  }

  .winline-player {
    --display: flex;
    --flex-direction: column;
    --flex-grow: 2;
    
    white-space: nowrap;
    /* padding-left: 1em;
    line-height: 1.2;
    */
    --padding-right: 3em;
    font-weight: 500;
    font-size: 40px;
  }
  .winline-arrow {
    margin-left: 1em;
    padding-left: 2em;
    --padding-right: 1em;
  }

  .marker{
  z-index: 99999;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 27.692px;
  height: 27.692px;
  border-radius: 100%;
  border: 2.308px solid #000;
  background: #FF296D;


}


  /* .winline-player-old {
    line-height: 1.2;
    font-weight: 500;
    font-size: 40px;
  } */
</style>
